export default __webpack_public_path__ + "static/media/MajorTraumaTriagev5.14NIMTTTv2_1FEB2022.8bc9e351.jpg";